import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sourceSelect", "manualSection", "campaignSection", "contactSelect", "campaignSelect"]

  connect() {
    this.toggleSource()
  }

  toggleSource() {
    const source = this.sourceSelectTarget.value

    if (source === "manual") {
      this.manualSectionTarget.style.display = "block"
      this.campaignSectionTarget.style.display = "none"

      // Enable manual select, disable campaign
      if (this.hasContactSelectTarget) {
        this.contactSelectTarget.disabled = false
      }
      if (this.hasCampaignSelectTarget) {
        this.campaignSelectTarget.disabled = true
      }
    } else {
      this.manualSectionTarget.style.display = "none"
      this.campaignSectionTarget.style.display = "block"

      // Enable campaign select, disable manual
      if (this.hasContactSelectTarget) {
        this.contactSelectTarget.disabled = true
      }
      if (this.hasCampaignSelectTarget) {
        this.campaignSelectTarget.disabled = false
      }
    }
  }
}
